import React, { Component, useState } from "react";
import { formatoSeparadorMilesValue } from '../../generico/utils/FormatoInput'
import DataTable from 'react-data-table-component';
import ResumenServices from "../../../services/resumenGeneral/resumenSocioService"
import Popup from "react-popup";
import AuthService from "../../../services/login/auth.service";
import { DataTableLoading } from "../../generico/DataTableLoading";
import ConfigService from "../../../services/configuracion/ConfigService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePdf } from "@fortawesome/free-solid-svg-icons";
import RuedaService from "../../../services/rueda/RuedaService";

const paginationOptions = {
  rangeSeparatorText: "de",
  noRowsPerPage: true
};

export const RuedaDetalle = ({ data }) => {

  // constructor(props) {
  //   super(props);
  //   state = this.getInitialState();
  // }

  console.log(data)

  const [state, setState] = useState({
    listaRuedaDetalle: [],
    datosCabecera: {},
    datosRueda: [],
    nombreSocio:null,
    usuario: AuthService.getCurrentUser()
  })

 /* componentDidMount() {
    let usuario = AuthService.getCurrentUser();

    this.setState({
      nombreSocio: usuario.nombreCompleto
    });
  }*/

  const [isLoading, setIsLoading] = useState(true)

  // getInitialState = () => ({
  //   listaRuedaDetalle: [],
  //   datosRueda: [],
  // })

  // componentDidMount() {

  // }

  const notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],
      },
    });

    

  const getDetalles = () => {
    var detalle = [];
    var cabecera={};

    // trackPromise(
    ResumenServices.detalleRueda("WEB", data.cuenta, data.grupo, data.plan)
      .then((response) => {
        var data = JSON.stringify(response.data);
        var jsonData = JSON.parse(data);
        //console.log(response)
        if (jsonData.codigo === "0") {
          cabecera=jsonData.resultadosCaberecas;

          for (var i = 0; i < jsonData.resultadosDetalles.length; i++) {
            detalle.push({
              cuota: jsonData.resultadosDetalles[i].numeroCuota,
              vencimiento: jsonData.resultadosDetalles[i].fechaVencimiento,
              estado: jsonData.resultadosDetalles[i].estado,
              fechaEstado: jsonData.resultadosDetalles[i].fechaEstado,
              importe: formatoSeparadorMilesValue(jsonData.resultadosDetalles[i].importeDebito),
              comprobante:jsonData.resultadosDetalles[i].comprobante
            })

          }

          setState({ ...state, listaRuedaDetalle: detalle, datosCabecera:cabecera[0] });

        } else {
          Popup.queue(notifiPopup("Info", jsonData.mensaje));
          setIsLoading(false);
          return;
        }

        setIsLoading(false);

      }
      ).catch(function (error) {
        setIsLoading(false);
        AuthService.logout()
        //console.log(error)
      })
      // )
      ;

     return detalle;
  }

  

  const getColumnDetalle = () => {
    return [
      {
        name: "N° Cuota",
        selector: row => row.cuota,
      },
      {
        name: "Fecha Vencimiento",
        selector: row => row.vencimiento
      },
      {
        name: "Estado",
        selector: row => row.estado,
      },
      {
        name: "Fecha Estado",
        selector: row => row.fechaEstado
      },
      {
        name: "Importe",
        selector: row => row.importe,
        width: "130px",
        right: true
      },
    
      {
        cell: (row) => (
          <div style={{ display: "flex", flexDirection: "column" }}>
            {row.comprobante!=null &&
            <button
              className="btn btn-cu-terciary btn-compro"
              style={ConfigService.ocultarSegunNombre("verContratoRueda")}
              onClick={() => descagarComprobanteReimpRueda(row)}>
              <FontAwesomeIcon style={{ color: "#fff" }} icon={faFilePdf} /> Comprobante
            </button>}
          </div>
        ),
        width: "150px",
      }

    ]; 
  }


  var detalles = state.listaRuedaDetalle

  if (detalles.length === 0 && data !== undefined) getDetalles() 

  //console.log(detalles)
  const descagarComprobanteReimpRueda = (datos) => {
    
   
      RuedaService.descagarComprobanteReimpRueda(datos,state.datosCabecera,state.usuario.nombreCompleto)
        .then((response) => {
          var fileURL = URL.createObjectURL(response.data);
          window.open(fileURL, "");         
        })
        .catch(function (error) {
          console.log(error);
        })
  }

  return (
    <DataTable
      noHeader={true}
      pagination={true}
      columns={getColumnDetalle()}
      data={detalles}
      dense={true}
      paginationComponentOptions={paginationOptions}
      noDataComponent="SIN DATOS"
      responsive={true}
      striped={true}
      progressPending={isLoading}
      progressComponent={<DataTableLoading />}
    />
  );
  

}